import './styles/cloud.scss'

interface Props {
    children: React.ReactNode,
    type?: string
}

export default function Cloud({children, type}: Props) {
    const classNames = `cloud ${type || ''}`
    return (
        <div className={classNames}>
            { children }
        </div>
    )
}